import { render, staticRenderFns } from "./AskLyndaPanel.vue?vue&type=template&id=45a245a2"
import script from "./AskLyndaPanel.vue?vue&type=script&lang=js"
export * from "./AskLyndaPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports